import React, { forwardRef, useImperativeHandle, useState } from 'react';

import PropTypes from 'prop-types';

import FileEditorModal from '../../../FileEditorModal';

const propTypes = {
  url: PropTypes.string,
  onChange: PropTypes.func,
  onSave: PropTypes.func,
};

const defaultProps = {
  url: '',
  onChange: null,
  onSave: null,
};

const EditFileFieldFileEditorModal = forwardRef(function EditFileFieldFileEditorModal(
  { url, onChange, onSave: onSaveProp, ...rest },
  ref,
) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    openModal: () => setIsModalOpen(true),
    closeModal: () => setIsModalOpen(false),
  }));

  function handleModalClose() {
    setIsModalOpen(false);
  }

  async function onPostSave({ file: newFile, fileConfiguration: newFileConfiguration }) {
    if (newFile && onChange) {
      const target = { files: [newFile] };
      await onChange({ target }, target);
    }
    if (onSaveProp) {
      await onSaveProp({ file: newFile, fileConfiguration: newFileConfiguration });
    }
    setIsModalOpen(false);
  }

  return (
    <FileEditorModal
      open={isModalOpen}
      onClose={handleModalClose}
      businessFile={url}
      onPostSave={onPostSave}
      {...rest}
    />
  );
});

EditFileFieldFileEditorModal.propTypes = propTypes;
EditFileFieldFileEditorModal.defaultProps = defaultProps;

export default EditFileFieldFileEditorModal;
